var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4173 8.24998C17.4173 4.70248 14.5482 1.83331 11.0007 1.83331C7.45315 1.83331 4.58398 4.70248 4.58398 8.24998C4.58398 11.5683 7.09565 14.2908 10.3132 14.63V16.7291H8.25065C7.87482 16.7291 7.56315 17.0408 7.56315 17.4166C7.56315 17.7925 7.87482 18.1041 8.25065 18.1041H10.3132V20.1666C10.3132 20.5425 10.6248 20.8541 11.0007 20.8541C11.3765 20.8541 11.6882 20.5425 11.6882 20.1666V18.1041H13.7507C14.1265 18.1041 14.4382 17.7925 14.4382 17.4166C14.4382 17.0408 14.1265 16.7291 13.7507 16.7291H11.6882V14.63C14.9057 14.2908 17.4173 11.5683 17.4173 8.24998Z",
    fill: "#0B101C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.17bb4b9e0b83a76dbe2a7ca73cb74b07.svg";
export { ForwardRef as ReactComponent };